import React from "react";
import { View, StyleSheet } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import { ThemedText } from "@/components/ThemedText";
import type { OverrideStringBarProps } from "./types";

export function OverrideStringBar({ value, originalKey, overrideKey }: OverrideStringBarProps) {
  const { colors } = useTheme();

  const data =
    typeof value === "string"
      ? (() => {
          try {
            return JSON.parse(value);
          } catch {
            return {};
          }
        })()
      : value || {};

  const original = data[originalKey] || null;
  const override = data[overrideKey] || null;
  const isOverridden = override != null && override !== "" && override !== original;
  const displayValue = isOverridden ? override : original;

  return (
    <View style={styles.container}>
      <ThemedText style={[styles.text, isOverridden && { color: colors.amber.text }]} numberOfLines={1}>
        {displayValue || "\u2014"}
      </ThemedText>
      {isOverridden && <View style={[styles.modifiedDot, { backgroundColor: colors.amber.border }]} />}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    flex: 1,
  },
  text: {
    fontSize: 16,
    flex: 1,
  },
  modifiedDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    marginLeft: "auto",
  },
});
